module.exports = __webpack_public_path__ + "img/logo1.6c94ae98.png";